import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const ViewAppointmentSingle = MatxLoadable({
    loader: () =>
        import ("./ViewAppointmentSingle")
})
const AllViewAppointmentSingle = MatxLoadable({
    loader: () =>
        import ("./AllViewAppointmentSingle")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const ViewAppointmentSingleRoutes = [
    {
        path: "/view_appointment_single",
        component: AllViewAppointmentSingle,
        // settings
    },

];

export default ViewAppointmentSingleRoutes;